import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

const styles = (theme) => ({});

class InputClone extends Component {
  render() {
    const { handlePropChange, type, label, property, propertyName } =
      this.props;
    return (
      <React.Fragment>
        <Grid item>
          <TextField
            type={type}
            label={label}
            placeholder={label}
            onChange={handlePropChange(propertyName)}
            value={property}
          />
        </Grid>
      </React.Fragment>
    );
  }
}

InputClone.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  propertyName: PropTypes.string.isRequired,
  handlePropChange: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "InputClone",
    withTheme: true,
  }),
)(InputClone);
